import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@availity/element';

import { useAppContext } from '@/context';
import { getJourneyRoute } from '@/global';

const Routing = () => {
  const navigate = useNavigate();
  const { queryParams = {} } = useAppContext();
  const { authIndexValue, authIndexType, composite_advice: compositeAdvice } = queryParams;

  // routes the user based on the authIndexValue
  useEffect(() => {
    if (compositeAdvice || authIndexType === 'composite_advice') {
      // for when a 2FA challenge (step up) is needed, and the web agent (on-prem) or IDG (cloud) redirects the user to FR UI.

      const documentCookie = document.cookie;
      const hasAvLoginDev = documentCookie.indexOf('loginTree=avLoginDev') >= 0;

      if (hasAvLoginDev) {
        navigate('/2fa-challenge-dev');
      } else {
        navigate('/2fa-challenge');
      }
    } else if (authIndexValue) {
      const route = getJourneyRoute(authIndexValue);

      // attempt to clear out query params before navigating to the correct route
      window.history.replaceState({}, '', '/');
      navigate(`/${route}`);
    } else {
      // Triggers login journey as a default route
      navigate('/login');
    }
  }, []);

  return <Box />;
};

export default Routing;
